import axiosClient from "./axiosClient";
import { IBankAccountDTO } from "@interfaces/IBankAccountDTO";

const BankAccountService = {
  getAllBankAccounts: async (
    includeInactive: boolean = false
  ): Promise<IBankAccountDTO[]> => {
    try {
      const response = await axiosClient.get(
        `/bank_account_api/accounts?include_inactive=${includeInactive}`
      );
      return response.data.data || [];
    } catch (error) {
      console.error("Error fetching bank accounts:", error);
      throw error;
    }
  },

  getBankAccountById: async (id: number): Promise<IBankAccountDTO | null> => {
    try {
      const response = await axiosClient.get(`/bank_account_api/account/${id}`);
      return response.data.data || null;
    } catch (error) {
      console.error(`Error fetching bank account ${id}:`, error);
      throw error;
    }
  },

  createBankAccount: async (data: {
    label: string;
    account_number: string;
    routing_number: string;
    next_check_number?: number;
  }): Promise<IBankAccountDTO> => {
    try {
      const response = await axiosClient.post(
        "/bank_account_api/account",
        data
      );
      return response.data.data;
    } catch (error) {
      console.error("Error creating bank account:", error);
      throw error;
    }
  },

  updateBankAccount: async (
    id: number,
    data: {
      label?: string;
      next_check_number?: number;
    }
  ): Promise<IBankAccountDTO> => {
    try {
      const response = await axiosClient.put(
        `/bank_account_api/account/${id}`,
        data
      );
      return response.data.data;
    } catch (error) {
      console.error(`Error updating bank account ${id}:`, error);
      throw error;
    }
  },

  revealBankAccountNumbers: async (
    id: number
  ): Promise<{ account_number: string; routing_number: string }> => {
    try {
      const response = await axiosClient.get(
        `/bank_account_api/account/${id}/reveal`
      );
      return response.data.data;
    } catch (error) {
      console.error(`Error revealing bank account ${id} numbers:`, error);
      throw error;
    }
  },

  toggleBankAccountStatus: async (id: number): Promise<IBankAccountDTO> => {
    try {
      const response = await axiosClient.put(
        `/bank_account_api/account/${id}/toggle`
      );
      return response.data.data;
    } catch (error) {
      console.error(`Error toggling bank account ${id} status:`, error);
      throw error;
    }
  },
};

export default BankAccountService;
